import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    BACK_LIQUIDACIONES_PRODUCTOS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.liquidaciones.productos.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LIQUIDACIONES_PRODUCTOS_CREAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.liquidaciones.productos.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LIQUIDACIONES_PRODUCTOS_RESUMEN : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.liquidaciones.productos.resumen'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LIQUIDACIONES_PRODUCTOS_EVENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.liquidaciones.productos.eventos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LIQUIDACIONES_PRODUCTOS_DELETE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.liquidaciones.productos.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LIQUIDACIONES_PRODUCTOS_SEND_REVIEW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.liquidaciones.productos.send-review'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    actions
};